export default __webpack_public_path__ + "static/media/logo-ford-oval.5b4327af.png";